<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    v-model:return-value="fechas"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ props }">
      <v-text-field
        v-model="fechas"
        label="Selecciona un periodo"
        prepend-icon="mdi-calendar"
        v-bind="props"
        :first-day-of-week="1"
        locale="es-se"
      ></v-text-field>
    </template>
    <v-date-picker v-model="fechas" multiple="range">
      <v-spacer></v-spacer>
      <v-btn variant="text" color="primary" @click="menu = false"> Cancelar </v-btn>
      <v-btn variant="text" color="primary" @click="buscar"> Buscar </v-btn>
    </v-date-picker>
  </v-menu>
</template>
<script>
export default {
  name: "PeriodoBusqueda",

  data:()=>({
    fechas: [],
    menu: false,
  }),

  methods: {
    formatearFecha(fecha) {
      if (fecha instanceof Date) {
        return new Date(fecha.getTime() - fecha.getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10)
      }
      return fecha
    },

    buscar(){
        this.$emit("buscar", this.fechas.map(this.formatearFecha))
        this.menu =  false
    }
  }
};
</script>
